import React, { Component } from 'react'
import { Button } from 'reactstrap'
import { CSVLink } from 'react-csv'
import PropTypes from 'prop-types'

/**
 * Provides CSV download option to share username data
 */
class DownloadCSVs extends Component {
  render() {
    const {
      school,
      studentsCSV,
      teachersCSV,
      usernameCSVsReady,
    } = this.props
    if (!usernameCSVsReady) return null
    return (
      <div>
        <CSVLink 
          data={studentsCSV}
          filename={`students ${school}.csv`}  
        >
          <Button>
            Student CSV
          </Button>
        </CSVLink>
        {' '}
        <CSVLink 
          data={teachersCSV}
          filename={`teachers ${school}.csv`}
        >
          <Button>
            Teacher CSV
          </Button>
        </CSVLink>
      </div>
    )
  }
}

const { string, array, bool } = PropTypes
DownloadCSVs.propTypes = {
  school: string,
  studentsCSV: array,
  teachersCSV: array,
  usernameCSVsReady: bool,
}

export default DownloadCSVs


// WEBPACK FOOTER //
// ./src/components/Assessment/UploadCSVComponents/DownloadCSVs.js